import { Typography } from "@circle-react-uikit/Typography";

interface DescriptionProps {
  children?: string | React.ReactNode;
  title: string;
}
export const Description = ({ title, children }: DescriptionProps) => (
  <Typography.BodySm color="text-default" textAlign="left">
    <span className="font-medium">{title}: </span>
    {children}
  </Typography.BodySm>
);
